import SectionMixin from '@/mixins/sectionMixin'
import TextWysiwyg from "@/components/global/text-wysiwyg"

export default {
    name: 'feature-shift-media-block',
    mixins: [SectionMixin],
    components: {
        'text-wysiwyg': TextWysiwyg,
    },
    props: {
        number: String,
        title: String,
        titleBgColor: String,
        description: String,
        mediaBgColor: String,
        videoUrl: String,
        imgUrl: String,
        buttonText: String,
        buttonLink: String,
        shift: Boolean,
        title_question: String,
        text_keyword: String,
    },
    data: () => {
        return {
            isIntersecting: false,
            visible: false,
        }
    },
    mounted() {
        this.$refs["markdown"].$el.innerHTML = this.convertBackspacesToBr(this.convertStrikethroughToSpan(this.$refs["markdown"].$el.innerHTML))
    },
    beforeDestroy() {

    },
    methods: {
        convertStrikethroughToSpan(text){
            return text.replace(/~~\W|~~\b/m,' <span class="highlight-box">').replace(/(~~)$/gm,'</span> ')
        },
        convertBackspacesToBr(text){
            return text.replace(/\n(?!.)/gm, '<br />');
        },

        show() {
            if (this.visible) {
                return
            }
            this.visible = true
        },
    }
};